export const hasGranularPermission = (user, moduleId, submenuId = null) => {
  if (user?.is_admin) return true;

  const targetId = submenuId || moduleId;

  // NEW: Check permitted_ids (simplified flat system)
  if (user?.permitted_ids?.length > 0) {
    return user.permitted_ids.includes(targetId);
  }

  // LEGACY: Check granular_permissions
  if (!user?.granular_permissions || user.granular_permissions.length === 0) {
    return user?.menu_permissions?.includes(moduleId) || false;
  }

  const module = user.granular_permissions.find((m) => m.module_id === moduleId);

  if (module) {
    if (!module.enabled) return false;
    if (!submenuId) return true;
    if (moduleId === submenuId) return true;

    const submenu = module.tabs?.find((t) => t.id === submenuId);
    if (submenu) return submenu?.enabled || false;

    for (const tab of module.tabs || []) {
      if (tab.page_tabs?.length) {
        const pageTab = tab.page_tabs.find((pt) => pt.id === submenuId);
        if (pageTab) return pageTab?.enabled || false;
      }
    }

    return user?.menu_permissions?.includes(submenuId) || false;
  }

  return user?.menu_permissions?.includes(moduleId) || false;
};
